import AttendLeaveAudit from './src/main';

/* istanbul ignore next */
AttendLeaveAudit.install = function(Vue) {
  Vue.component(AttendLeaveAudit.name, AttendLeaveAudit);
};

export default AttendLeaveAudit;
